import * as React from "react";
import { Card } from "antd";
import styled from "styled-components";
import calendar from "../../images/calendar.svg";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ImageDownloadable from "../ImageElements/ImageDownloadable";
import { EventShortProps } from "../../types";
import { convertEventDate } from "../../utils/DateTimeHandler";

const StyledCard = styled(Card)`
  	box-shadow: 0px 1px 8px 0px #00000014;
	height: 460px;
  	min-width: 380px;
  	overflow: hidden;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	.ant-card-body {
		padding: 20px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
  
	.header {
		font-size: 20px;
		font-weight: 700;
		line-height: 28px;
		color: #222222;
	}
`

const TextDiv = styled.div<{ lines: number }>`
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${props => props.lines};
	white-space: pre-wrap;

	.text {
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
	}
`

const CompanyName = styled.p`
	font-size: 16px;
	font-weight: 600;
	line-height: 22px;
	color: #45505A;
`

const DateTime = styled.p`
	font-size: 14px;
	font-weight: 600;
	line-height: 22px;
	color: #45505A;
`

type BasicEventCardProps = {
	event: EventShortProps;
	children?: React.ReactNode
}

export const BasicEventCard = ({ event, children }: BasicEventCardProps) => {
	const navigate = useNavigate();
	
	const [lines, setLines] = useState(2);
	const [eventInfo, setEventInfo] = useState({day: '', month: '', year: '', time: '', status: ''});

	const headerRef = useRef<null | HTMLParagraphElement>(null)
	const subHeaderRef = useRef<null | HTMLDivElement>(null)

	useEffect(() => {
		const info = convertEventDate(event.dateTimeOfEvent);
		if (info) setEventInfo(info);

		const headerHeight = headerRef.current?.clientHeight || 0;
		const subHeaderHeight = subHeaderRef.current?.clientHeight || 0;

		const calculatedLines = Math.floor((236 - 68 - headerHeight - subHeaderHeight - 24 - (children ? 45 : 0))  / 22);

		setLines((calculatedLines >= 1) ? calculatedLines : 1);
	}, []);

	return (
		<StyledCard
			cover={
				<ImageDownloadable id={event.eventCoverImage} type={'event'} preview={false} style={{objectFit : "cover", borderRadius: '8px', maxHeight: '224px'}}/>
			}
			bordered={false}
			onClick={() => navigate('/event/' + event.id)}
		>
			<div className="d-flex flex-column" style={{ gap: "12px" }}>
				<div className="different-edges-container">
					<p className="header left-edge" ref={headerRef}>{event.name}</p>
					{(eventInfo.status) && <div className="find-candidate-card right-edge"> {eventInfo.status} </div>}
				</div>
				<div ref={subHeaderRef}>
					<CompanyName>{event.companyName}</CompanyName>
					<div className="d-inline-flex">
						<img src={calendar} height="16px" style={{ marginTop: "3px" }} alt='' />
						&nbsp;
						<DateTime>
							{eventInfo.day} {eventInfo.month} {eventInfo.year} в {eventInfo.time}
						</DateTime>
					</div>
				</div>
				<TextDiv lines={lines}>
					<p className="text">
						{event.shortDescription}
					</p>
				</TextDiv>
			</div>
			{children}
		</StyledCard>
	)
}